/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
// React Imports
import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// Lodash
import _ from 'lodash';

// i18n
import { Translate } from 'react-redux-i18n';

// React Spectrum Components
import { Button } from '@adobe/react-spectrum';

// React Router
import { withRouter } from '../withRouter';

// Styles
import '../../styles/PartnerInfoCard.scss';

const PartnerInfoCard = ({
  partnerDetail,
}) => {
  const [maxAwardsListNum, setMaxAwardsListNum] = useState(5);
  const [maxInitiativesListNum, setMaxInitiativesListNum] = useState(5);
  const dispatch = useDispatch();

  const getAccentColor = () => {
    const accentColorBar = document.querySelector('.accent-color');
    if (accentColorBar) {
      accentColorBar.style.backgroundColor = partnerDetail?.companyInfo?.accentColor;
      accentColorBar.style.border = `${partnerDetail?.companyInfo?.accentColor} 1px solid`;
    }
  };

  const setPartnerLogo = () => {
    const logo = document.querySelector('.partner-logo');
    if (logo) {
      logo.style.backgroundImage = `url(${partnerDetail?.companyInfo?.logoUrl || ''})`;
    }
  };

  useEffect(() => {
    if (_.has(partnerDetail, 'companyInfo.accentColor') && _.has(partnerDetail, 'companyInfo.logoUrl')) {
      getAccentColor();
      setPartnerLogo();
    }
  }, [partnerDetail]);

  const renderPartnerLevelIcon = (partnerLevel) => {
    switch (partnerLevel) {
      case 'Bronze':
        return (
          <div className="bronzeIcon badgeIcon">
            <Translate value="partner_finder.detail.bronze_partner" />
          </div>
        );
      case 'Silver':
        return (
          <div className="silverIcon badgeIcon">
            <Translate value="partner_finder.detail.silver_partner" />
          </div>
        );
      case 'Gold':
        return (
          <div className="goldIcon badgeIcon">
            <Translate value="partner_finder.detail.gold_partner" />
          </div>
        );
      case 'Platinum':
      case 'Platinum (Regional)':
        return (
          <div className="platinumIcon badgeIcon">
            <Translate value="partner_finder.detail.platinum_partner" />
          </div>
        );
      default:
        return (
          <div className="defaultIcon badgeIcon">
            <Translate value="partner_finder.detail.partner" />
          </div>
        );
    }
  };

  const renderLogoLetter = () => {
    if (_.has(partnerDetail, 'companyInfo.logoUrl')) {
      if (!partnerDetail.companyInfo.logoUrl) {
        return partnerDetail.companyInfo.name[0];
      }
    }
    return null;
  };

  const partnerInfoTopSection = (
    <>
      <div className="info-top-section">
        <div className="accent-color" />
        <div className="partner-logo-container">
          <div className="partner-logo">
            {renderLogoLetter()}
          </div>
        </div>
        <div className="partner-level">
          {renderPartnerLevelIcon(partnerDetail?.companyInfo?.level)}
        </div>
      </div>
    </>
  );

  const tempAwardsList = partnerDetail?.resources?.Badge || [];

  const handleAwardsShowMore = () => {
    setMaxAwardsListNum(tempAwardsList.length);
  };

  const handleAwardsShowLess = () => {
    setMaxAwardsListNum(5);
  };

  const partnerAwardsSection = (
    <>
      {partnerDetail?.resources?.Badge?.length > 0 && (
        <div className="info-initiatives-section">
          <h2>Partner Awards</h2>
          {tempAwardsList
            .sort((a, b) => (a.name < b.name ? 1 : -1))
            .slice(0, tempAwardsList.length > maxAwardsListNum ? maxAwardsListNum : tempAwardsList.length)
            .map((item) => (
              <div style={{ fontSize: '16px', color: '#222222', marginBottom: '10px' }}>
                {item.name}
              </div>
            ))}
          {tempAwardsList.length > 5 && maxAwardsListNum <= 5 && (
          <Button onClick={handleAwardsShowMore} UNSAFE_className="showMoreButton">
            Show More
          </Button>
          )}
          {tempAwardsList.length > 5 && maxAwardsListNum > 5 && (
          <Button onClick={handleAwardsShowLess} UNSAFE_className="showMoreButton">
            Show Less
          </Button>
          )}
        </div>
      )}
    </>
  );

  const tempInitiativesList = partnerDetail?.resources?.Initiative?.filter((item) => item.active) || [];

  const handleInitiativesShowMore = () => {
    setMaxInitiativesListNum(tempInitiativesList.length);
  };

  const handleInitiativesShowLess = () => {
    setMaxInitiativesListNum(5);
  };

  const partnerInitiativesSection = (
    <>
      {tempInitiativesList.length > 0 && (
        <div className="info-initiatives-section">
          <h2>Initiatives</h2>
          {tempInitiativesList
            .filter((item) => item.active)
            .slice(0, tempInitiativesList.length > maxInitiativesListNum ? maxInitiativesListNum : tempInitiativesList.length)
            .map((item) => (
              <div style={{ fontSize: '16px', color: '#222222', marginBottom: '10px' }}>
                {item.name}
              </div>
            ))}

          {tempInitiativesList.length > 5 && maxInitiativesListNum <= 5 && (
          <Button onClick={handleInitiativesShowMore} UNSAFE_className="showMoreButton">
            Show More
          </Button>
          )}

          {tempInitiativesList.length > 5 && maxInitiativesListNum > 5 && (
          <Button onClick={handleInitiativesShowLess} UNSAFE_className="showMoreButton">
            Show Less
          </Button>
          )}
        </div>
      )}
    </>
  );

  return (
    <div className="PartnerInfoCard">
      {partnerInfoTopSection}
      {partnerAwardsSection}
      {partnerInitiativesSection}
    </div>
  );
};

PartnerInfoCard.propTypes = {
  partnerDetail: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  partnerDetail: state?.partnerDetail,
});

export default withRouter(connect(mapStateToProps)(PartnerInfoCard));
